/**
 * @generated SignedSource<<bd3846436047aca0f089d68256da0d61>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AskFellowSuggestedQuestions_EmptyState_conversation$data = {
  readonly context: {
    readonly filters: string | null;
    readonly name: string;
  } | null;
  readonly suggestedQuestions: ReadonlyArray<{
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"AskFellowSuggestedQuestions_SuggestedQuestionButton_suggestedQuestion">;
  }>;
  readonly " $fragmentType": "AskFellowSuggestedQuestions_EmptyState_conversation";
};
export type AskFellowSuggestedQuestions_EmptyState_conversation$key = {
  readonly " $data"?: AskFellowSuggestedQuestions_EmptyState_conversation$data;
  readonly " $fragmentSpreads": FragmentRefs<"AskFellowSuggestedQuestions_EmptyState_conversation">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AskFellowSuggestedQuestions_EmptyState_conversation",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SuggestedQuestion",
      "kind": "LinkedField",
      "name": "suggestedQuestions",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "AskFellowSuggestedQuestions_SuggestedQuestionButton_suggestedQuestion"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AskCopilotConversationContext",
      "kind": "LinkedField",
      "name": "context",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "filters",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AskCopilotConversation",
  "abstractKey": null
};

(node as any).hash = "a16681ea3734abd3ad6c48dc97350aac";

export default node;
